import { Col, Row } from 'react-bootstrap';
import { IssuePolicyMarketing } from '../../../Marketing';
import React from 'react';
import { Field } from 'redux-form';
import { MarketingAdditionalInfo } from '../../../Marketing/components';

export const MarketingBox = ({
  isMarketingEnabled,
  isInsuranceMarketingOptionsEnabled,
  isCarInsuranceMarketingEnabled,
  isHomeInsuranceMarketingEnabled,
}) => {
  if (!isMarketingEnabled && !isInsuranceMarketingOptionsEnabled) {
    return null;
  }

  return (
    <>
      <div className="marketing-box">
        <Row>
          <Col sm={12}>
            <div className="hr" style={{ marginBottom: '10px' }} />
            <div className="issue-policy-title">Marketing Preferences</div>
          </Col>
        </Row>

        {isMarketingEnabled && (
          <Field
            name={'data.attributes.metadata.adults.0.marketing_options'}
            component={IssuePolicyMarketing}
            showText
          />
        )}

        {isInsuranceMarketingOptionsEnabled && (
          <MarketingAdditionalInfo
            customerEditPage={false}
            isCarInsuranceMarketingEnabled={isCarInsuranceMarketingEnabled}
            isHomeInsuranceMarketingEnabled={isHomeInsuranceMarketingEnabled}
          />
        )}
      </div>
      <div className="hr" style={{ marginBottom: '10px', marginTop: '10px' }} />
    </>
  );
};
